import type { TShip } from '../types';

export function getShipAt(ships: TShip[], row: number, col: number): number {
  for (let i = 0; i < ships.length; i++) {
    const ship = ships[i];
    for (const cell of ship) {
      if (cell.row === row && cell.col === col) {
        return i;
      }
    }
  }
  return -1;
}

export function checkCellHit(
  ships: TShip[],
  row: number,
  col: number,
): { hit: boolean; shipIndex: number } {
  const shipIndex = getShipAt(ships, row, col);
  return {
    hit: shipIndex >= 0,
    shipIndex,
  };
}
